(function () {
  const REVEAL_SELECTOR = 'main .shopify-section, body > footer';

  /** @type {IntersectionObserver | null} */
  let revealObserver = null;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const onReady = () => {
    if (typeof window.BOYHEROEnsureGSAP !== 'function') return;

    window.BOYHEROEnsureGSAP()
      .then((gsap) => {
        if (!gsap) return;

        document.body.classList.add('gsap-motion-ready');

        setupScrollReveal(gsap);

        document.addEventListener('shopify:section:load', () => {
          setupScrollReveal(gsap);
        });
      })
      .catch((error) => {
        console.warn('[BOYHERO] GSAP initialization failed:', error);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  /**
   * @param {GSAPStatic} gsap
   */
  function setupScrollReveal(gsap) {
    const sections = document.querySelectorAll(REVEAL_SELECTOR);
    if (!sections.length) return;
    const revealDistance = prefersReducedMotion ? 0 : 26;
    const revealDuration = prefersReducedMotion ? 0.28 : 0.65;
    const revealEase = prefersReducedMotion ? 'power1.out' : 'power3.out';
    const revealSection = (section, observer) => {
      section.dataset.scrollReveal = 'visible';

      gsap.to(section, {
        autoAlpha: 1,
        y: 0,
        duration: revealDuration,
        ease: revealEase,
        overwrite: true,
        clearProps: 'opacity,visibility,transform',
      });

      observer?.unobserve(section);
    };

    if (!('IntersectionObserver' in window)) {
      sections.forEach((section) => {
        if (!(section instanceof HTMLElement)) return;
        section.dataset.scrollReveal = 'visible';
        gsap.set(section, { autoAlpha: 1, y: 0, clearProps: 'opacity,visibility,transform' });
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            if (!(entry.target instanceof HTMLElement)) return;

            revealSection(entry.target, observer);
          });
        },
        {
          root: null,
          threshold: 0.01,
          rootMargin: '0px 0px -8% 0px',
        }
      );
    }

    sections.forEach((section) => {
      if (!(section instanceof HTMLElement)) return;
      if (section.dataset.scrollReveal === 'visible') return;
      if (section.dataset.scrollRevealInit === 'true') return;

      const sectionRect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const startsInViewport = sectionRect.top < viewportHeight * 0.92 && sectionRect.bottom > 0;

      section.dataset.scrollReveal = 'pending';
      section.dataset.scrollRevealInit = 'true';

      if (startsInViewport) {
        revealSection(section);
        return;
      }

      gsap.set(section, { autoAlpha: 0, y: revealDistance });
      revealObserver.observe(section);

      window.setTimeout(() => {
        if (section.dataset.scrollReveal === 'pending') {
          revealSection(section, revealObserver);
        }
      }, 1200);
    });
  }

})();
